/**
 * De legenda met de vijf statussen.
 *
 * De statussen staan hier in één lijst, en elk blokje krijgt dezelfde
 * `status-`klasse als het statuslabel op de lesrij. In styles.css staat de kleur
 * daardoor één keer, in een selector die label én legenda-blokje noemt — de legenda
 * kán dus niet uit de pas gaan lopen met wat er in het rooster staat.
 *
 * Welke status welke kleur heeft en waarom, staat in docs/huisstijl.md §4.3.
 */
import type { Status } from '../types';

const STATUSSEN: ReadonlyArray<{ status: Status; label: string }> = [
  { status: 'normal', label: 'Normaal' },
  { status: 'cancelled', label: 'Vervallen' },
  { status: 'changed', label: 'Gewijzigd' },
  { status: 'new', label: 'Nieuw / extra' },
  { status: 'exam', label: 'Toets' },
];

export function Legenda() {
  return (
    <div className="legend">
      {STATUSSEN.map(({ status, label }) => (
        <div className="legend-item" key={status}>
          <span className={`legend-dot status-${status}`} />
          {label}
        </div>
      ))}
    </div>
  );
}
